import React, { useState, useEffect } from "react";
import styles from "./slider.module.scss";
import Newprojectimg1 from "../../../assets/newhomepageimg/newprojectimg1.webp";
import Newprojectimg2 from "../../../assets/newhomepageimg/newprojectimg2.webp";
import Newprojectimg3 from "../../../assets/newhomepageimg/newprojectimg3.webp";
import Newprojectimg4 from "../../../assets/newhomepageimg/newprojectimg4.webp";
import { Link } from "react-router-dom";
interface Slide {
  title: string;
  description: string;
  image: string;
  cta: string;
}

const slides = [
  {
    title: "ZEEQR",
    description:
      "ZEEQR offers NFC-enabled digital business cards that let professionals share contact details and social links with a simple tap. Their eco-friendly cards work without an app and are popular across the UAE & India.",
    image: Newprojectimg1,
    cta: "Learn More",
    link: "https://zeeqr.com/"
  },
  {
    title: "Asset Glance",
    description:
      "Asset Glance is a smart and flexible platform that helps businesses manage and track their assets in real time. It simplifies daily operations, improves visibility, and boosts overall efficiency through an easy-to-use interface.",
    image: Newprojectimg2,
    cta: "Learn More",
    link: "https://assetglance.com/"
  },
  {
    title: "360° View",
    description:
      "360View.ai is an intuitive platform that lets you create interactive 360° digital experiences of real-world spaces. It’s perfect for showcasing interiors, venues, and environments in a visually immersive way.",
    image: Newprojectimg3,
    cta: "Learn More",
    link: "https://360view.ai/"
  },
  {
    title: "Wezappy",
    description:
      "Wezappy is a trusted platform that helps people buy and sell everything from cars and properties to electronics and furniture. It makes local trading easy, quick, and reliable for everyone.",
    image: Newprojectimg4,
    cta: "Learn More",
    link: " https://wezappy.com/"
  },
];
const HeroSlider: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState<number>(0);

  // Auto-slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const goToSlide = (index: number): void => {
    setCurrentSlide(index);
  };

  const handleButtonClick = (slideTitle: string): void => {
    console.log(`Clicked: ${slideTitle}`);
    // Add your button click logic here
  };

  return (
    <div className={styles.main}>
      <div className={styles.sliderContainer}>
        <div 
          className={styles.slideTrack}
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {slides.map((slide, idx) => (
            <div key={idx} className={styles.slideItem}>
              <div className={styles.slide}>
                <div
                  className={styles.imageSide}
                  style={{ backgroundImage: `url(${slide.image})` }}
                >
                  <div className={styles.contentSide}>
                    <h2 className={styles.h2title}>{slide.title}</h2>
                    <p className={styles.description}>{slide.description}</p>
                 <Link target="_blank" to={slide.link} className={styles.button}>{slide.cta}</Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Dots Navigation */}
      <ul className={styles.dots}>
        {slides.map((_, index) => (
          <li key={index}>
            <button
              className={`${styles.dot} ${index === currentSlide ? styles.dotActive : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default HeroSlider;